import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';

export class GetEnclosureCardAction implements Action {
  public static readonly type = 'GetEnclosureCardAction';

  constructor(public group: Group) {
  }

  public type = GetEnclosureCardAction.type;
}
